var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("img", {
            attrs: { src: require("../assets/img/goods/payfail.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "suctip1" }, [_vm._v("支付失败")]),
          _vm._v(" "),
          _c("div", { staticClass: "suctip2" }, [
            _vm._v("哎呀呀是什么原因呢～")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "returnbtn", on: { click: _vm.gohome } }, [
            _vm._v("返回主页")
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }